import { FC } from 'react';
import { Button, EmojiDisplay } from '@/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { navigationPages } from '@/config';

import resultBlurred from '@/assets/images/analyze/result-blurred.webp';

import styles from './PromoFlow.module.sass';

interface PromoFlowProps {}

const PromoFlow: FC<PromoFlowProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToTariffs = () => {
    navigate(navigationPages.TARIFFS.path);
  };

  return (
    <div className={styles.result}>
      <img src={resultBlurred} alt="" className={styles.example} />

      <div className={styles.info}>
        <EmojiDisplay emoji="☝" className={styles.icon} />
        <div className={styles.title}>
          {t('translation.promo_tpl_adv_title')}
        </div>
        <div className={styles.description}>
          {t('translation.promo_tpl_adv_addr_text')}
        </div>
        <Button
          size="m"
          type="primary-gradient"
          corner="rect"
          onClick={handleGoToTariffs}
        >
          <span>{t('translation.promo_tpl_adv_btn')}</span>
        </Button>
      </div>
    </div>
  );
};

export default PromoFlow;
